import type { BibleVersionId } from "./bible";

export interface ScriptureBookmark {
  id: string;
  translation: BibleVersionId;
  book: string;
  chapter: number;
  verseStart: number;
  verseEnd: number;
  updatedAt: number;
}

export function scriptureBookmarkPath(bookmark: ScriptureBookmark) {
  const query = new URLSearchParams({
    verse: String(bookmark.verseStart),
    version: bookmark.translation,
  });
  return `/scripture/${encodeURIComponent(bookmark.book)}/${bookmark.chapter}?${query.toString()}`;
}

export function bookmarkMatchesLocation(
  bookmark: ScriptureBookmark,
  location: {
    translation: BibleVersionId;
    book: string;
    chapter: number;
    verse: number;
  },
) {
  return (
    bookmark.translation === location.translation &&
    bookmark.book === location.book &&
    bookmark.chapter === location.chapter &&
    bookmark.verseStart <= location.verse &&
    bookmark.verseEnd >= location.verse
  );
}

export function bookmarkedBooks(bookmarks: ScriptureBookmark[]) {
  return new Set(bookmarks.map((bookmark) => bookmark.book));
}

export function bookmarkedChapters(bookmarks: ScriptureBookmark[], book: string) {
  return new Set(
    bookmarks
      .filter((bookmark) => bookmark.book === book)
      .map((bookmark) => bookmark.chapter),
  );
}
